import { produce } from 'immer';

import { User } from '../../models';
import { ActionType } from './types';

export interface UsersState {
  all: User[];
  isLoading: boolean;
  serverError: string;
  total: number;
  isDeleteLoading: boolean;
  isAddEditLoading: boolean;
}

export const initialState = {
  all: [],
  isLoading: false,
  serverError: null,
  total: 0,
  isDeleteLoading: false,
  isAddEditLoading: false,
};

const stores = produce((draft: UsersState, action) => {
  const { payload, error } = action;
  switch (action.type) {
    case ActionType.GET_USERS:
    case ActionType.GET_MORE_USERS:
      draft.isLoading = true;
      break;
    case ActionType.GET_USERS_FULFILLED:
      draft.isLoading = false;
      draft.all = payload?.data?.data || [];
      draft.total = payload?.data?.total;
      break;
    case ActionType.GET_MORE_USERS_FULFILLED:
      draft.isLoading = false;
      draft.all = draft.all.concat(payload?.data?.data || []);
      break;
    case ActionType.GET_USERS_REJECTED:
    case ActionType.GET_MORE_USERS_REJECTED:
      draft.serverError = error.message;
      draft.isLoading = false;
      break;
    case ActionType.DELETE_USER:
      draft.isDeleteLoading = true;
      break;
    case ActionType.DELETE_USER_FULFILLED:
      draft.isDeleteLoading = false;
      break;
    case ActionType.DELETE_USER_REJECTED:
      draft.serverError = error.message;
      draft.isDeleteLoading = false;
      break;
    case ActionType.ADD_USER:
    case ActionType.EDIT_USER:
      draft.isAddEditLoading = true;
      break;
    case ActionType.ADD_USER_FULFILLED:
    case ActionType.EDIT_USER_FULFILLED:
      draft.isAddEditLoading = false;
      break;
    case ActionType.ADD_USER_REJECTED:
    case ActionType.EDIT_USER_REJECTED:
      draft.serverError = error.message;
      draft.isAddEditLoading = false;
      break;
  }
}, initialState);

export default stores;
